@if (inputData(); as inputData) {
  <nk-person-common-info [inputData]="inputData"></nk-person-common-info>
  <nk-person-ownership [inputData]="inputData"></nk-person-ownership>
  <nk-person-company-roles [inputData]="inputData"></nk-person-company-roles>
}
@if (screeningEntityUuid$ | async; as screeningEntityUuid) {
  <nk-screening-case-table
    [screeningEntityUuid]="screeningEntityUuid"
    [screeningCaseComposites]="screeningCaseComposites()"
    [isPrintVersion]="isPrintVersion">
  </nk-screening-case-table>
  <nk-screening-adverse-media-card-list
    [screeningEntityUuid]="screeningEntityUuid"></nk-screening-adverse-media-card-list>
  <nk-screening-action-card-list [screeningEntityUuid]="screeningEntityUuid"></nk-screening-action-card-list>
} @else if (isLoadingScreeningEntityUuid()) {
  <nk-progress [isLoading]="true"></nk-progress>
} @else {
  <nk-screening-action-card-list></nk-screening-action-card-list>
}
